import * as Location from 'expo-location';

export let GeoLocation = (async () => {
    let { status } = await Location.requestPermissionsAsync();
    let _geoLocation;
    if (status !== 'granted') {
        return _geoLocation = {notGranted: true};
    }

    let location = await Location.getCurrentPositionAsync({});

    return _geoLocation = location;
})();